import clsx from 'clsx';
import { forwardRef } from '@wordpress/element';
import { isRTL } from '@wordpress/i18n';
import { Text } from '../../text';
import { POSITIONS } from './utils';
import styles from './style.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
const CORNER_OFFSET = 4;
const CURSOR_OFFSET_TOP = CORNER_OFFSET * 2.5;
function Label({
  label,
  position = POSITIONS.corner,
  zIndex = 1000,
  ...props
}, ref) {
  const showLabel = !!label;
  const isBottom = position === POSITIONS.bottom;
  const isCorner = position === POSITIONS.corner;
  if (!showLabel) {
    return null;
  }
  let style = {
    opacity: showLabel ? 1 : undefined,
    zIndex
  };
  let labelStyle = {};
  if (isBottom) {
    style = {
      ...style,
      position: 'absolute',
      bottom: CURSOR_OFFSET_TOP * -1,
      left: '50%',
      transform: 'translate(-50%, 0)'
    };
    labelStyle = {
      transform: `translate(0, 100%)`
    };
  }
  if (isCorner) {
    style = {
      ...style,
      position: 'absolute',
      top: CORNER_OFFSET,
      right: isRTL() ? undefined : CORNER_OFFSET,
      left: isRTL() ? CORNER_OFFSET : undefined
    };
  }
  return /*#__PURE__*/_jsx("div", {
    "aria-hidden": "true",
    className: clsx('components-resizable-tooltip__tooltip-wrapper', styles['tooltip-wrapper']),
    ref: ref,
    style: style,
    ...props,
    children: /*#__PURE__*/_jsx("div", {
      className: clsx('components-resizable-tooltip__tooltip', styles.tooltip),
      style: labelStyle,
      children: /*#__PURE__*/_jsx(Text, {
        as: "span",
        className: styles['label-text'],
        children: label
      })
    })
  });
}
const ForwardedComponent = forwardRef(Label);
export default ForwardedComponent;